/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Sub_Downgrade_UnlimitedInputs */



/**
* | output |
* | --- |
* | "Unlimited" |
*
* @param {Sub_Downgrade_UnlimitedInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const sub_downgrade_unlimited = /** @type {((inputs?: Sub_Downgrade_UnlimitedInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Sub_Downgrade_UnlimitedInputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return /** @type {LocalizedString} */ ("Unbegrenzt")
	return /** @type {LocalizedString} */ ("Unlimited")
});